import React from "react";

import CacheSettings from "./CacheSettings";
import CurrentPlan from "./CurrentTrainerPlan";

import "./styles.css";

const Settings: React.FC = () => {
  return (
    <div className="m-auto w-full max-w-7xl py-20">
      <CurrentPlan />
      <span style={{ margin: 10 }} />
      <CacheSettings />
    </div>
  );
};

export default Settings;
